import apiClient from './client';

export interface MeetingAnalytics {
  totalMeetings: number;
  bookedMeetings: number;
  heldMeetings: number;
  noShowMeetings: number;
  cancelledMeetings: number;
  noShowRate: number;
  averageDuration: number;
  meetingsByStage: { [stage: string]: number };
  meetingsByMedium: { [medium: string]: number };
}

export const meetingAnalyticsApi = {
  getAnalytics: async (filters?: {
    startDate?: string;
    endDate?: string;
    leadId?: number;
    userId?: number;
  }): Promise<MeetingAnalytics> => {
    const response = await apiClient.get<{ success: boolean; data: MeetingAnalytics }>('/meeting-analytics', { params: filters });
    return response.data.data;
  },
};
